<template>
    <section class="content">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <div class="row" style="row-gap: 15px;">
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <label class="control-label">Asal Pengiriman</label>
                                            <label class="control-label text-primary cursor-pointer" v-on:click="selectWarehouse">Pilih Alamat <i class="fi fi-rr-angle-right"></i></label>
                                        </div>
                                    </div>
                                    <v-select required label="name" name="sender_addr_id" :filterable="false" :options="addrOptions1" v-model="form.sender_addr_id" :reduce="(opt) => opt.id" @search="onSearch1">
                                    <template slot="no-options"> Ketik asal pengiriman... </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.lokasi }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.lokasi }}
                                        </div>
                                    </template>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <label class="control-label">Tujuran Pengiriman</label>
                                    <v-select required label="name" name="addr_id" :filterable="false" :options="addrOptions2" v-model="form.addr_id" :reduce="(opt) => opt.id" @search="onSearch2">
                                    <template slot="no-options"> Ketik tujuan pengiriman... </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.lokasi }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.lokasi }}
                                        </div>
                                    </template>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <label class="control-label">Berat (Kg)</label>
                                    <input class="form-control" v-model="form.weight" type="number" value="1" min="0.5" max="99" step="0.1" required="required" placeholder="Bisa desimal" name="weight" 
                                    onkeydown="return (event.ctrlKey || event.altKey 
                                    || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
                                    || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
                                    || (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))"/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <label class="control-label">Panjang (Cm)</label>
                                    <input class="form-control" v-model="form.l" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="l" 
                                    onkeydown="return (event.ctrlKey || event.altKey 
                                    || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
                                    || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
                                    || (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))"/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <label class="control-label">Lebar (Cm)</label>
                                    <input class="form-control" v-model="form.w" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="w" 
                                    onkeydown="return (event.ctrlKey || event.altKey 
                                    || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
                                    || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
                                    || (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))"/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group m-0">
                                    <label class="control-label">Tinggi (Cm)</label>
                                    <input class="form-control" v-model="form.h" type="number" value="1" min="0.5" step="0.1" required="required" placeholder="Bisa desimal" name="h" 
                                    onkeydown="return (event.ctrlKey || event.altKey 
                                    || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) 
                                    || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) 
                                    || (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46))"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="d-flex align-items-center h-100">
                            <button type="submit" :disabled="checking" v-on:click="search" class="btn btn-primary btn-md float-right">Cek Ongkir <span v-if="checking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-if="resultOngkir.length > 0">
            <div class="card-body">
                <div class="row d-flex justify-content-between align-items-center">
                    <div class="col">
                        <div class="form-control p-0 h-100" :class="(service_category == 0 ? 'badge-cod' : 'border')" style="border-width: 2px;">
                            <input type="radio" id="regular" name="service_category" v-model="service_category" value="0" hidden  @click="onToggleChange(0)"/>
                            <label for="regular" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{ 'text-secondary' : service_category != 0 }">Reguler</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-control p-0 h-100" :class="(service_category == 2 ? 'badge-cod' : 'border')" style="border-width: 2px;">
                            <input type="radio" id="sameday" name="service_category" v-model="service_category" value="2" hidden  @click="onToggleChange(2)"/>
                            <label for="sameday" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{ 'text-secondary' : service_category != 2 }">Sameday</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-control p-0 h-100" :class="(service_category == 3 ? 'badge-cod' : 'border')" style="border-width: 2px;">
                            <input type="radio" id="nextday" name="service_category" v-model="service_category" value="3" hidden  @click="onToggleChange(3)"/>
                            <label for="nextday" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{'text-secondary' : service_category != 3}">Nextday</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-control p-0 h-100" :class="(service_category == 1 ? 'badge-cod' : 'border')" style="border-width: 2px;">
                            <input type="radio" id="cargo" name="service_category" v-model="service_category" value="1" hidden  @click="onToggleChange(1)"/>
                            <label for="cargo" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{'text-secondary' : service_category != 1}">Cargo</label>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="input-group mb-2" v-for="(item, index) in listCourierSelect" :key="index" :class="[index < listCourierSelect.length - 1 ? 'border-bottom' : '', service_promo.includes(item.service) ? ' fade-in-left-3 bg-promo' : 'fade-in-top']">
                        <div style="min-height: 50px; flex: 1 1 auto;width: 1%;" class="w-auto p-3" :key="item.service">
                            <div class="row">
                                <div class="col-md col-sm-12">
                                    <img :src="getKurirLogo(item.kurir)" style="height:40px;" :class="{'bg-light rounded' : service_promo.includes(item.service)}" />
                                </div>
                                <div class="col-md col-sm-12" v-if="item.rating > 0">
                                    <div  class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Rating kurir</span>
                                        <div class="row" style="align-items: center;">
                                            <star-rating :inline="true" :star-size="15" :read-only="true" :show-rating="false" :rating="Number(item.rating)" style="margin-bottom: 6px;" :increment="0.01"></star-rating>
                                            <h6 class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px; margin-left: 5px;">{{ item.rating }}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12">
                                    <div class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Service kurir</span>
                                        <h6 class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;">{{ item.serviceName }}</h6>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12">
                                    <div class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Estimasi</span>
                                        <h6 v-if="item.etd_thru == false" class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;"> - </h6>
                                        <h6 v-else class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;">{{ item.etd_from }} - {{ item.etd_thru }} hari</h6>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12">
                                    <div class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Tipe Kiriman</span>
                                        <div>
                                            <span v-if="item.cod == '1'" class="badge badge-cod" style="margin-right: 2px;">COD</span>
                                            <span class="badge badge-cod">NONCOD</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12">
                                    <div class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Tarif Ongkir</span>
                                        <h6 class="description-header"><s class="text-secondary" :class="{'text-stroke' : service_promo.includes(item.service)}">Rp{{ formatRupiah(item.maxPrice) }}</s> <span class="text-success font-weight-bold" :class="{'text-stroke' : service_promo.includes(item.service)}">Rp{{ formatRupiah(item.price_after_disc)}}</span>&nbsp;<i class="fas fa-info-circle" :title="'Diskon '+item.percent_cashback+'%'"></i></h6>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12" v-if="item.weight != form.weight && item.weight > 1">
                                    <div class="description text-left mt-0">
                                        <span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Berat Volumetrik</span>
                                        <h6 :title="'Pengukuran berat dihitung berdasarkan volume'" class="description-header" style="margin-top: 5px;">{{ item.weight}} Kg &nbsp;</h6>
                                    </div>
                                </div>
                                <div class="col-md col-sm-12">
                                    <div class="description text-left mt-0">
                                        <router-link :to="{name: 'Buat Pesanan', params: {data_from_ongkir: data_ongkir, data_receiver_ongkir : form.addr_id, data_product : form}}">
                                            <div :disabled="checking" class="btn btn-primary btn-md float-right" :class="{'border-light' : service_promo.includes(item.service)}" style="margin-top: 5px;">Buat&nbsp;Pesanan</div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" v-if="sender.addr_id && ongkirInProgres.length < listCourier.length">
                    <div class="col">
                        <div class="progress rounded-pill">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" :class="['bg-primary']" role="progressbar" :aria-valuenow="(ongkirInProgres.length / listCourier.length) * 100" aria-valuemin="0" aria-valuemax="100" :style="{ 'width': (ongkirInProgres.length / listCourier.length) * 100 + '%' }">{{ (ongkirInProgres.length / listCourier.length) * 100 }}%</div>
                        </div>
                    </div>
                    <div class="col-auto pl-0">
                        <i class="fi fi-rr-cross cursor-pointer" v-on:click="stopLoadOngkir"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div
            v-for="row in resultOngkir"
            :key="row.service"
            :value="row.service"
            class="col-md-12">
        
        </div> -->
        <WarehouseCekOngkir :show="show" @input="onChangeWarehouse" v-model="sender" />
    </section>
</template>
<script src="https://unpkg.com/vue-star-rating@next/dist/VueStarRating.umd.min.js"></script>
<script>
import { createTable, authFetch, formatRupiah } from '@/libs/hxcore';
import $ from 'jquery';
// import datepicker from '@/components/Datepicker';
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import WarehouseCekOngkir from "@/dialog/WarehouseCekOngkir";
import moment from "moment";
import StarRating from 'vue-star-rating';

export default {
    name: 'CekOngkir',
    components: {
        vSelect,
        WarehouseCekOngkir,
        StarRating,
        // datepicker,
    },
    data() {
        return {
            service_category: null,
			service_promo: ["UDREGFLAT","00"],
			service_recommendation:  ["UDREGFLAT","00","06"],
            errors: [],
            addrOptions1: [],
            addrOptions2: [],
            senderOptions: [],
            resultOngkir: [],
            roles: '',
            checking: false,
            show: false,
            form: {
                addr_id: null,
                sender_addr_id: null,
                weight: 1,
                w: 10,
                l: 10,
                h: 10,
            },
            signals: null,
            totalCourier: [],
            listCourier: [],
            listCourierSelect: [
                {
                    service: null,
                    kurir: null,
                    rating: null,
                    serviceName: null,
                    etd_thru: null,
                    etd_from: null,
                    cod: null,
                    maxPrice: null,
                    price_after_disc: null,
                    percent_cashback: null,
                    weight: null
                }
            ],
            ongkirInProgres: [],
            sender: {},
            data_ongkir: {},
        }
    },
    created: function() {
        // this.roles = this.$route.meta.roles;
        // console.log('load initial data', this.$route)
        //this.loadAddress();
        this.loadSenderAddress();
    },
    methods: {
        formatRupiah(data){
            return formatRupiah(data);
        },
        getKurirLogo(kurir) {
            try {
                const fileName = kurir?.toLowerCase();

                return require(`../assets/img/${fileName}.png`) // the module request
            } catch (e) {
                return '';
            }
        },
        search: function() {
            let self = this;
            self.form.addr_id = self.form.addr_id;
            self.form.sender_addr_id = self.form.sender_addr_id;
            self.form.weight = self.form.weight;
            if (!self.form.sender_addr_id) {
                self.resultOngkir = [];
                return Swal.fire("Asal gudang belum dipilih!", ``, "error");
            }
            if (!self.form.addr_id) {
                self.resultOngkir = [];
                return Swal.fire("Tujuan pengiriman belum dipilih!", ``, "error");
            }
            if (self.form.weight > 99) {
                self.resultOngkir = [];
                return Swal.fire("Berat maksimum 99 Kg!", ``, "error");
            }
            //this.loadOngkir(self.form);
            this.stopLoadOngkir();
            this.mapOngkir();
        },
        stopLoadOngkir: function() {
			if(this.signals!=null){
				this.signals.abort();
				this.ongkirInProgres = [];
			}
		},
        loadAddress() {
            let route;
                route = "/order/cekongkir/address";
            authFetch(route).then((res) => {
                res.json().then((json) => {
                    if (json.success) {
                        // this.sender = json.data;
                        this.addrOptions1.push({
                            id: json.data.addr_id,
                            lokasi: json.data.kota + " / " + json.data.kecamatan,
                        });
                        this.addrOptions2.push({
                            id: json.data.addr_id,
                            lokasi: json.data.kota + " / " + json.data.kecamatan,
                        });
                    }
                });
            });
        },
        loadSenderAddress() {
            authFetch('/order/cekongkir/asalgudang')
            .then(res => {
                if (res.status === 201) {

                } else if (res.status === 400) {}
                return res.json();
            })
            .then(js => {
                this.senderOptions = js.data;
                $('.loading-overlay').removeClass('show');
            });
        },
        onSearch1(search, loading) {
            if (search.length > 3) {
                loading(true);
                //this.search(loading, search, this);
                var vm = this;
                authFetch(`/order/wilayah?q=${escape(search)}`).then((res) => {
                    res.json().then((json) => (vm.addrOptions1 = json.items));
                    loading(false);
                });
            }
        },
        onSearch2(search, loading) {
            if (search.length > 3) {
                loading(true);
                //this.search(loading, search, this);
                var vm = this;
                authFetch(`/order/wilayah?q=${escape(search)}`).then((res) => {
                    res.json().then((json) => (vm.addrOptions2 = json.items));
                    loading(false);
                });
            }
        },
        loadOngkir(params) {
            const self = this;
            let data;
            let route;
            data = Object.keys(params)
            .map(
                (key) =>
                encodeURIComponent(key) + "=" + ((params[key] ===false || params[key] === undefined)?0 : encodeURIComponent(params[key]))
            )
            .join("&");
            route = "/order/cekongkir/cek?" + data;
            // var weight = self.formItem.weight;
            // if (!weight) weight = 1;
            // if (s_id) {
            //     route = `/order/nilai_ongkir/${courier_id}/${s_id}/${r_id}/${weight}`;
            // } else {
            //     route = "/order/nilai_ongkir/854/887";
            // }
            // if (self.form.shipper_id) {
            //     route = route + '?shipper_id=' + self.form.shipper_id;
            // }
            this.checking = true;
            authFetch(route).then((res) => {
                res.json().then((json) => {
                    console.log("data ", json);
                    self.resultOngkir = json;
                    this.checking = false;
                });
            });
        },
        async loadCourier() {
			// this.resetService();
			let route = "/order/kurir";
			try {
				await authFetch(route).then(res => {
					res.json().then(json => {
						if (json.success == true) {
							this.listCourier = json.data;
							this.service_promo = json.service_promo;
							this.service_recommendation = json.service_recommendation;
							if (this.form.addr_id && this.form.sender_addr_id && this.form.weight){
								this.mapOngkir();
							}
						} else {
							Swal.fire({
								title: "Oops...",
								icon: "error",
								text: json.message,
								showCloseButton: true
							});
						}

					});
				});
			} catch (error) {
				
			}
		},
        stopLoadOngkir: function() {
			if(this.signals!=null){
				this.signals.abort();
				this.ongkirInProgres = [];
			}
		},
        mapOngkir() {
            const self = this;
            this.ongkirInProgres =[];
			let data;
			this.ongkirInProgres =[];
			this.resultOngkir = [];
			if (this.signals != null) {
				this.signals.abort();
			}
			const controller = new AbortController();
			this.signals = controller;
			data = this.listCourier.length > 0 ? this.listCourier.map((val,key) => {
				var data = {};
				data.addr_id = self.form.addr_id;
				data.sender_addr_id = self.form.sender_addr_id;
				data.weight = self.form.weight;
				data.courier = val.id;
				data.order_type = this.form.order_type;
				data.w = self.form.w;
				data.h = self.form.h;
				data.l = self.form.l;
				this.newLoadOngkir(data);
			}) : this.loadCourier();
		},
		newLoadOngkir(params) {
			const self = this;
			params.w = this.form.w;
			params.h = this.form.h;
			params.l = this.form.l;
			params.codStatus = 0;
			const courierRecommendation = 1;
			let data;
            if(!this.form.addr_id)
				return;
			data = Object.keys(params)
				.map(
					key =>
						encodeURIComponent(key) +
						"=" +
						(params[key] === false || params[key] === undefined
							? 0
							: encodeURIComponent(params[key]))
				)
				.join("&");
			this.checking = true;

			authFetch("/order/ongkir?" + data, {signal : this.signals.signal}).then(res => {
				res.json().then(json => {
					const dataToProcess = Array.isArray(json) ? json : (json.data ? json.data : [json]);
					dataToProcess.forEach(async (val) => {
						await new Promise((resolve) => {
							this.resultOngkir = [...this.resultOngkir, val].sort((a, b) => {
							const aIdx = this.service_recommendation.indexOf(a.service || '');
							const bIdx = this.service_recommendation.indexOf(b.service || '');
							if (aIdx === -1 && bIdx === -1) return 0;
							if (aIdx === -1) return 1;
							if (bIdx === -1) return -1;
							return aIdx - bIdx;
							});
							resolve();
						});
					});
					this.checking = false;
					if (Object.keys(this.resultOngkir).length == 1 && Object.keys(this.listCourier).length == 1) {
						this.selectService(0);
					} else {
						this.showServiceList = true;
					}
					this.onToggleChange(99);
				}).
				finish(
					this.ongkirInProgres.push(...params.courier)
				);
			});
		},
        selectWarehouse: function() {
			this.show = !this.show;
		},
        onChangeWarehouse: function(e)
		{
            this.addrOptions1 = [e];
            this.form = {
                addr_id: e.addr_id,
                sender_addr_id: e.addr_id,
                weight: this.form.weight,
                w: this.form.w,
                l: this.form.l,
                h: this.form.h,
            },
			this.sender.error = false;
            e.item_wight = this.form.weight;
            e.item_width = this.form.w;
            e.item_height = this.form.h;
            e.item_long = this.form.l;
            this.data_ongkir = e;
		},
		onToggleChange: function(filter)
		{
            var listCourierSelect = [];
			if (filter == 99 || this.service_category == filter) {
				this.listCourierSelect = this.resultOngkir;
				this.service_category = 99;
			} else {
				for (let i = 0; i < this.resultOngkir.length; i++) {
					if (this.resultOngkir[i].category == filter){
						listCourierSelect.push(this.resultOngkir[i]);
					}
				}
				this.listCourierSelect = listCourierSelect;
			}
		},
    },
    mounted() {
        const e = this.$refs;
        var self = this;
    },
    watch: {
		ongkirInProgres: function(val) {
			//do something when the data changes.
			Object.keys(this.ongkirInProgres).length==Object.keys(this.listCourier).length==1
			if (Object.keys(this.ongkirInProgres).length==Object.keys(this.listCourier).length==1) {
				this.signals=null;
			}
		},
	},
}
</script>
<style>
.text-stroke {
  text-shadow:
    0.5px 0 0 white,
   -0.5px 0 0 white,
    0 0.5px 0 white,
    0 -0.5px 0 white;
}

@keyframes shimmer-infinite {
    0% {
        background-position: 50% 0;
    }
    50% {
        background-position: 0% 0;
    }
    100% {
        background-position: 50% 0;
    }
}

@keyframes ease-in-right {
    0% {
        opacity: 0;
        transform: translateX(-20%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes ease-in-top {
    0% {
        opacity: 0;
        transform: translateY(-20%);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in-left-3 {
    background: linear-gradient(90deg, #FF7203, #FF9300);
    /* background-size: 200% 100%; */
    animation: 
        shimmer-infinite 30s infinite linear,
        ease-in-right 0.3s backwards;
    transition: transform 0.1s;
}

.bg-promo {
	background-color: #FF7203;
	/* background-image: url("~@/assets/img/bg-withdraw.svg"); */
	background-image: url("~@/assets/img/BackgroundCourier.svg");
	background-repeat: no-repeat;
	background-size: 100%;
	border-radius: 6px;
	border: 1px solid #944100;
	color:#ffffff;
	background-size: cover;
}

.fade-in-top {
    animation: ease-in-top 0.1s forwards;
    transition: transform 0.1s;
}
</style>